import { makeStyles } from '@material-ui/styles';
import { Spin } from 'antd';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles(theme => ({
  loading: {
    ...theme.flex.center,
  },
}));

const SpinLoading = ({ className, ...otherProps }) => {
  const classes = useStyles();

  return <Spin className={classNames(classes.loading, className)} {...otherProps} />;
};

export default SpinLoading;
